import React from "react";
import Homeconts from "./Pages/home";
import ProductLanding from "./Components/Product/ProductLanding";
import Test2 from "./Components/Product/Test2";
import Head from "./Components/Header/header";
import Browseby from "./Components/BrowseBy/Browseby";

import { ScrollRestoration } from "react-router-dom";
import Cart from "./Components/Cart/Cart";
const App = () => {
  return (
    <>
      
      {/* <Cart /> */}
      <Homeconts />
      {/* <ProductLanding /> */}
      {/* <Browseby /> */}
      {/* <Test2 /> */}
      {/* <Head /> */}
      {/* <ScrollRestoration/> */}
    </>
  );
};

export default App;
